import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations } from 'vuex';
import EditMixin from '@/components/core/dtwin/editMixin';
import detailsViewMixin from '@/components/core/virtualDevice/detailsViewMixin';
import GeoDataMixin from '@/components/core/dtwin/geoDataMixin';
import mixinActionBoxStyles from '@/components/core/mixinActionBoxStyles';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'ViewVirtualDevicesDetails',
  mixins: [EditMixin, GeoDataMixin, mixinActionBoxStyles, detailsViewMixin],
  data: function data() {
    return {
      tabItem: this.$route.query.stateId ? 'tab-states' : this.$route.query.ruleId ? 'tab-rules' : 'tab-deviceinfo',
      shouldOpenStateDetail: !!this.$route.query.stateId
    };
  },
  computed: {
    headerBG: function headerBG() {
      if (get(this.twinObject, 'data.twinImageId')) {
        return "".concat(process.env.VUE_APP_API_HOST).concat(process.env.VUE_APP_API_PATH, "/upload/").concat(this.twinObject.data.twinImageId);
      }

      return null;
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  watch: {},
  created: function created() {
    this.baseLink = 'virtual-devices';
    this.apiMethodGet = 'virtualDeviceGet';
    this.apiGeoHistoryFetchMethod = 'virtualDeviceFetchGeoHistory';
    this.apiMethodUpdate = 'virtualDeviceUpdate';
    this.apiMethodToggleDisabled = 'virtualDeviceUpdateDisabled';
    this.permissionSubject = 'VirtualDevice';
    this.twinObject = {
      data: {},
      properties: {
        bridge: {
          deviceData: {}
        }
      }
    };
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['snackbar'])), {}, {
    onChangeDeviceDriver: function onChangeDeviceDriver(newDriverId) {
      var clonedTwinObject = cloneDeep(this.twinObject);
      delete clonedTwinObject.data.virtualDevice.deviceTypeId;
      clonedTwinObject.data.virtualDevice.deviceDriverId = newDriverId;
      this.twinObject = clonedTwinObject;
    },
    onChangeDeviceType: function onChangeDeviceType(newDeviceTypeId) {
      var clonedTwinObject = cloneDeep(this.twinObject);
      delete clonedTwinObject.data.virtualDevice.deviceDriverId;
      clonedTwinObject.data.virtualDevice.deviceTypeId = newDeviceTypeId;
      this.twinObject = clonedTwinObject;
    }
  })
};